import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Container, Row, Col, Button } from "react-bootstrap";
import { FaArrowRight, FaArrowLeft, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const Inicio = ({ idUsuario }) => {
  const [consultas, setConsultas] = useState([]);
  const [mostrarProximos, setMostrarProximos] = useState(false);
  const [turnosHoy, setTurnosHoy] = useState([]);
  const [pacientesRecientes, setPacientesRecientes] = useState([]);
  const [odontologas, setOdontologas] = useState([]);
  const [selectedOdontologa, setSelectedOdontologa] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); 

  useEffect(() => {
    if (!idUsuario) return;

    const fetchOdontologas = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/odontologas`);
        setOdontologas(response.data);
      } catch (error) {
        console.error("Error al obtener odontólogas:", error);
      }
    };

    const fetchConsultas = async () => {
      try {
        let url = `${process.env.REACT_APP_BACKEND_URL}/consultas/notificaciones/${idUsuario}`;
        if (idUsuario === 5 || idUsuario === 6) {
          if (selectedOdontologa) {
            url += `?idOdontologa=${selectedOdontologa}`;
          } else {
            setConsultas([]);
            setTurnosHoy([]);
            setPacientesRecientes([]);
            return;
          }
        }
        const response = await axios.get(url);
        setConsultas(response.data);
      } catch (error) {
        console.error("Error al obtener consultas:", error);
      }
    };

    const fetchTurnosHoy = async () => {
      try {
        let url = `${process.env.REACT_APP_BACKEND_URL}/consultas/turnos-hoy/${idUsuario}`;
        if (idUsuario === 5 || idUsuario === 6) {
          if (selectedOdontologa) {
            url += `?idOdontologa=${selectedOdontologa}`;
          } else {
            setTurnosHoy([]);
            return;
          }
        }
        const response = await axios.get(url);
        setTurnosHoy(response.data);
      } catch (error) {
        console.error("Error al obtener turnos de hoy:", error);
      }
    };

    const fetchPacientesRecientes = async () => {
      try {
        let url = `${process.env.REACT_APP_BACKEND_URL}/consultas/pacientes-recientes/${idUsuario}`;
        if (idUsuario === 5 || idUsuario === 6) {
          if (selectedOdontologa) {
            url += `?idOdontologa=${selectedOdontologa}`;
          } else {
            setPacientesRecientes([]);
            return;
          }
        }
        const response = await axios.get(url);
        setPacientesRecientes(response.data);
      } catch (error) {
        console.error("Error al obtener pacientes recientes:", error);
      }
    };

    fetchOdontologas();
    fetchConsultas();
    fetchTurnosHoy();
    fetchPacientesRecientes();
  }, [idUsuario, selectedOdontologa]);

  // Función para alternar entre Últimos Turnos y Próximos Turnos
  const toggleOrden = () => {
    setMostrarProximos(!mostrarProximos);
    setConsultas([...consultas].sort((a, b) => {
      const fechaA = new Date(`${a.Horario.fecha} ${a.Horario.hora}`);
      const fechaB = new Date(`${b.Horario.fecha} ${b.Horario.hora}`);
      return mostrarProximos ? fechaB - fechaA : fechaA - fechaB;
    }));
  };

  // Genera el mensaje de WhatsApp
  const generarMensajeWhatsApp = (consulta) => {
    return `Buenos días, ${consulta.Paciente.nombre_paciente}. 
Le informamos que su turno para el día ${consulta.Horario.fecha} a las ${consulta.Horario.hora} con la ${consulta.Horario.odontologa.nombre} ha sido agendado con éxito. 
Lo esperamos en Galería Moreno (Moreno esquina Salas y Valdez) Planta Alta, Local 14, Yerba Buena. 
Saludos.`;
  };

  // Genera el enlace de WhatsApp
  const obtenerLinkWhatsApp = (consulta) => {
    const numero = consulta.Paciente.telefono.replace(/\D/g, ""); // Limpia el número
    const mensaje = encodeURIComponent(generarMensajeWhatsApp(consulta));
    return `https://wa.me/${numero}?text=${mensaje}`;
  };

  // Genera el enlace de Email para Gmail
  const obtenerLinkEmail = (consulta) => {
    const asunto = encodeURIComponent("Confirmación de Turno Odontológico");
    const mensaje = encodeURIComponent(generarMensajeWhatsApp(consulta));
    return `https://mail.google.com/mail/?view=cm&fs=1&to=${consulta.Paciente.correo}&su=${asunto}&body=${mensaje}`;
  };

  return (
    <Container fluid className="bg-dark min-vh-100 m-0 p-4">
    {/* Encabezado de Bienvenida */}
    <Card className="bg-primary text-black p-3 mb-4">
    {(idUsuario === 5 || idUsuario === 6) && (
  <Row className="justify-content-center">
    {odontologas.map((od) => (
      <Col key={od.id} xs={6} sm={4} md="auto" className="mb-2 text-center">
        <Button
          variant={selectedOdontologa === od.id ? "light" : "dark"}
          onClick={() => setSelectedOdontologa(od.id)}
        >
          {od.nombre}
        </Button>
      </Col>
    ))}
  </Row>
)}

      {idUsuario !== 5 && idUsuario !== 6 && (
        <h2 className="text-center mt-3">
          Bienvenida, {consultas.length > 0 && consultas[0].Horario.odontologa.nombre}
        </h2>
      )}
    </Card>

    <Row className="gx-3">
      {/* Panel de Últimos Turnos Agendados */}
      <Col lg={7}>
        <Card className="bg-light p-3 shadow-sm" style={{ height: "85vh", overflowY: "auto" }}>
          <Card.Header className="bg-primary text-black d-flex justify-content-between align-items-center">
            <h4>{mostrarProximos ? "Próximos Turnos" : "Últimos Turnos Agendados"}</h4>
            <Button variant="dark" size="sm" onClick={toggleOrden}>
              {mostrarProximos ? <FaArrowLeft /> : <FaArrowRight />}
            </Button>
          </Card.Header>
          <Card.Body>
            {consultas.length > 0 ? (
              consultas.map((consulta) => (
                <Card key={consulta.idconsultas} className="mb-3 p-2 shadow-sm">
                  <Card.Body>
                    {/* Información de la consulta */}
                    <div>
                      <p className="mb-1">
                        <strong>{consulta.Horario.fecha} - {consulta.Horario.hora}</strong>
                      </p>
                      <h5 className="mb-1">{consulta.Paciente?.nombre_paciente}</h5>
                      <p className="mb-1 text-muted">{consulta.Paciente?.correo}</p>
                      <p className="mb-1">{consulta.Paciente?.telefono}</p>
                      <p className="mb-1">DNI: {consulta.Paciente?.dni_paciente}</p>
                      {consulta.descripcion && (
                        <p className="mt-2 fst-italic">{consulta.descripcion}</p>
                      )}
                    </div>

                    {/* Botones - Debajo en móviles */}
                    <div className="d-flex flex-column flex-md-row justify-content-md-end mt-3 mt-md-0">
                      <Button
                        variant="success"
                        className="mb-2 mb-md-0 me-md-2"
                        href={obtenerLinkWhatsApp(consulta)}
                        target="_blank"
                      >
                        <FaWhatsapp /> WhatsApp
                      </Button>
                      <Button
                        variant="primary"
                        href={obtenerLinkEmail(consulta)}
                        target="_blank"
                      >
                        <FaEnvelope /> Email
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              ))
            ) : (
              <p>No hay consultas recientes.</p>
            )}
          </Card.Body>
        </Card>
      </Col>

      <Col lg={5}>
        {/* Turnos de Hoy */}
        <Card className="bg-light p-3 shadow-sm mb-3">
          <Card.Header className="bg-primary text-black">
            <h4>Turnos de Hoy</h4>
          </Card.Header>
          <Card.Body style={{ overflowY: "auto", maxHeight: "40vh" }}>
            {turnosHoy.length > 0 ? (
              turnosHoy.map((consulta) => (
                <Card key={consulta.dni_paciente} className="mb-2 p-2 shadow-sm">
                  <Card.Body>
                    <p className="mb-1"><strong>{consulta.fecha} - {consulta.hora}</strong></p>
                    <h5 className="mb-1">{consulta.nombre_paciente}</h5>
                    <p className="mb-1 text-muted">{consulta.correo}</p>
                    <p className="mb-1">{consulta.telefono}</p>
                    <p className="mb-1">DNI: {consulta.dni_paciente}</p>
                  </Card.Body>
                </Card>
              ))
            ) : (
              <p>No hay turnos para hoy.</p>
            )}
          </Card.Body>
        </Card>

        {/* Pacientes Recientes */}
        <Card className="bg-light p-3 shadow-sm">
          <Card.Header className="bg-primary text-black">
            <h4>Pacientes Recientes</h4>
          </Card.Header>
          <Card.Body style={{ overflowY: "auto", maxHeight: "40vh" }}>
            {pacientesRecientes.length > 0 ? (
              pacientesRecientes.map((consulta) => (
                <Card key={consulta.dni_paciente} className="mb-2 p-2 shadow-sm">
                  <Card.Body>
                    <h5 className="mb-1">{consulta.nombre_paciente}</h5>
                    <p className="mb-1 text-muted">{consulta.correo}</p>
                    <p className="mb-1">{consulta.telefono}</p>
                    <p className="mb-1">DNI: {consulta.dni_paciente}</p>
                    <p className="mb-1 text-muted">Última consulta: {consulta.ultima_consulta_fecha} - {consulta.ultima_consulta_hora}</p>
                  </Card.Body>
                </Card>
              ))
            ) : (
              <p>No hay pacientes recientes.</p>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>
  );
};

export default Inicio;
